import { BoxProps } from '@jfs/ui-new'
import { TextStyle, ViewStyle } from 'react-native'
import { viewShadowStyle } from '../../util/util'
const styles = {
  mainContainerWeb: {
    marginHorizontal: 16,
    overflow: "auto",
    maxHeight: '80vh',
    position: 'relative',
    marginTop: 16,
    paddingBottom: 40,
  } as BoxProps,
  aligncenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    paddingBottom: 16,
    margin: 16,
  } as BoxProps,
  tabbar: {
    backgroundColor: 'white',
    marginTop: 20,
    paddingLeft: 16,
    marginRight: 'auto',
    width: '100%',
    height: 48,
  } as ViewStyle,
  stickyHeader: {
    position: 'sticky',
    top: -2,
    paddingVertical: 16,
    backgroundColor: 'white',
    zIndex: 100,
    marginTop: -16,
  } as unknown as BoxProps,
  refundBody: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
  } as ViewStyle,

  errorView: {
    textAlign: 'center',
    margin: 8,
    color: 'red',
  } as TextStyle,

  loadingView: { width: '100%', textAlign: 'center' } as TextStyle,

  listItemContainer: {
    flex: 1,
    flexDirection: 'row',
    paddingTop: 16,
    paddingLeft: 24,
    paddingRight: 24,
  } as BoxProps,
  dateSelectorContainer: {
    flexDirection: 'row',
    marginTop: 20,
    flexWrap: 'wrap',
    maxWidth: '100%',
    justifyContent: 'flex-start',
  } as BoxProps,
  textLayout: {
    flex: 1,
    justifyContent: 'flex-start',
    flexDirection: 'row',
    padding: 0,
    margin: 0,
  } as BoxProps,
  hoverHeader: {
    padding: 24,
  } as BoxProps,
  hoverDetails: {
    flex: 1,
    flexDirection: 'row',
    margin: 24,
    padding: 0,
  } as BoxProps,
  hoverColumn: {
    flex: 1,
    flexDirection: 'column',
    margin: 0,
    padding: 0,
  } as BoxProps,
  modalList: {
    backgroundColor: 'WHITE',
    position: 'relative',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  } as BoxProps,
  modalListItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: 20,
    paddingVertical: 20,
    borderBottomWidth: 1,
    borderBottomColor: 'GREY_SEPARATOR',
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  buttonContainer: {
    paddingHorizontal: 10,
    paddingVertical: 10,
  } as BoxProps,
  settlmentNote: {
    marginLeft: 16,
  } as BoxProps,
  bars: {
    backgroundColor: 'WHITE',
    padding: 8,
    marginTop: 0,
    ...viewShadowStyle,
  } as BoxProps,
}

export default styles
